import React, { useState, useEffect } from 'react';
import { AZUL, LARANJA, CINZA, VERDE } from '../styles/colors';
import { db, logoutUsuario } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';

const STATUS = {
  pendente:    { label: 'Aguardando',  cor: '#f59e0b', bg: '#fffbeb' },
  confirmado:  { label: 'Confirmado',  cor: '#3b82f6', bg: '#eff6ff' },
  em_entrega:  { label: 'Em entrega',  cor: '#8b5cf6', bg: '#f5f3ff' },
  entregue:    { label: 'Entregue',    cor: '#16a34a', bg: '#f0fdf4' },
};

function Historico({ onNavegar, perfilAtivo }) {
  const [pedidos, setPedidos]             = useState([]);
  const [loading, setLoading]             = useState(true);
  const [expandido, setExpandido]         = useState(null);
  const [filtroStatus, setFiltroStatus]   = useState('todos');

  useEffect(() => {
    const clienteId = perfilAtivo?.uid;
    if (!clienteId) {
      setPedidos([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const q = query(
      collection(db, 'pedidos'),
      where('clienteId', '==', clienteId)
    );

    const unsubscribe = onSnapshot(q, (snap) => {
      const lista = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      lista.sort((a, b) => (b.criadoEm?.seconds || 0) - (a.criadoEm?.seconds || 0));
      setPedidos(lista);
      setLoading(false);
    }, (erro) => {
      console.error('Erro ao escutar pedidos:', erro);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [perfilAtivo?.uid]);

  async function handleSair() {
    if (!window.confirm('Deseja sair da sua conta?')) return;
    try { await logoutUsuario(); } catch (e) { console.error(e); }
    localStorage.removeItem('perfil');
    window.location.reload();
  }

  function formatarData(timestamp) {
    if (!timestamp?.seconds) return '—';
    const d = new Date(timestamp.seconds * 1000);
    return d.toLocaleDateString('pt-BR');
  }

  function formatarTotal(total) {
    if (!total) return 'R$ 0,00';
    return Number(total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  const pedidosFiltrados = pedidos.filter(p =>
    filtroStatus === 'todos' || p.status === filtroStatus
  );

  function toggleExpandir(id) {
    setExpandido(prev => prev === id ? null : id);
  }

  const navItems = [
    { id: 'home',      emoji: '🏠', label: 'Início'   },
    { id: 'catalogo',  emoji: '📦', label: 'Catálogo' },
    { id: 'carrinho',  emoji: '🛒', label: 'Carrinho' },
    { id: 'historico', emoji: '📋', label: 'Pedidos'  },
    { id: 'perfil',    emoji: '👤', label: 'Perfil'   },
  ];

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: CINZA }}>

      {/* Header */}
      <div style={{ background: AZUL, padding: '14px 18px 0' }}>
        {/* Linha 1: título + sair */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
          <div style={{ color: '#fff', fontSize: 16, fontWeight: 600 }}>Meus Pedidos</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {pedidos.length > 0 && (
              <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 10, padding: '2px 8px', fontSize: 11, fontWeight: 600, color: '#fff' }}>
                {pedidos.length}
              </div>
            )}
            <button onClick={handleSair}
              style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 11, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>
              Sair
            </button>
          </div>
        </div>

        {/* Filtro status */}
        <div style={{ display: 'flex', gap: 7, overflowX: 'auto', paddingBottom: 8 }}>
          {[
            { id: 'todos',      label: 'Todos'      },
            { id: 'pendente',   label: 'Aguardando' },
            { id: 'confirmado', label: 'Confirmado' },
            { id: 'em_entrega', label: 'Em entrega' },
            { id: 'entregue',   label: 'Entregue'   },
          ].map(f => (
            <div key={f.id} onClick={() => setFiltroStatus(f.id)}
              style={{ flexShrink: 0, background: filtroStatus === f.id ? '#fff' : 'rgba(255,255,255,0.15)', borderRadius: 20, padding: '5px 13px', fontSize: 11, fontWeight: 600, color: filtroStatus === f.id ? AZUL : 'rgba(255,255,255,0.8)', cursor: 'pointer', whiteSpace: 'nowrap' }}>
              {f.label}
            </div>
          ))}
        </div>

        {/* Linha 2: navegação */}
        <div style={{ display: 'flex', borderTop: '1px solid rgba(255,255,255,0.15)' }}>
          {navItems.map(item => (
            <div key={item.id} onClick={() => onNavegar(item.id)}
              style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '8px 4px 10px', cursor: 'pointer', gap: 3, borderBottom: item.id === 'historico' ? '2px solid #fff' : '2px solid transparent' }}>
              <span style={{ fontSize: 18 }}>{item.emoji}</span>
              <span style={{ fontSize: 9, color: item.id === 'historico' ? '#fff' : 'rgba(255,255,255,0.6)', fontWeight: item.id === 'historico' ? 600 : 400 }}>{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Lista */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '12px 12px 0' }}>

        {loading ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 20px', gap: 12 }}>
            <span style={{ fontSize: 32 }}>⏳</span>
            <span style={{ fontSize: 13, color: '#aaa' }}>Carregando pedidos...</span>
          </div>
        ) : pedidosFiltrados.length === 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 20px', gap: 12 }}>
            <span style={{ fontSize: 44 }}>📋</span>
            <span style={{ fontSize: 14, fontWeight: 500, color: '#1a1a1a' }}>
              {pedidos.length === 0 ? 'Nenhum pedido ainda' : 'Nenhum pedido encontrado'}
            </span>
            <span style={{ fontSize: 12, color: '#aaa', textAlign: 'center' }}>
              {pedidos.length === 0 ? 'Seus pedidos aparecerão aqui após a compra' : ''}
            </span>
            {pedidos.length === 0 ? (
              <button onClick={() => onNavegar('catalogo')}
                style={{ background: AZUL, border: 'none', borderRadius: 8, padding: '8px 18px', fontSize: 12, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>
                Ver Catálogo
              </button>
            ) : (
              <button onClick={() => setFiltroStatus('todos')}
                style={{ background: AZUL, border: 'none', borderRadius: 8, padding: '8px 18px', fontSize: 12, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>
                Ver todos
              </button>
            )}
          </div>
        ) : (
          pedidosFiltrados.map(pedido => {
            const st    = STATUS[pedido.status] || STATUS['pendente'];
            const aberto = expandido === pedido.id;

            return (
              <div key={pedido.id}
                style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', marginBottom: 10, overflow: 'hidden' }}>

                <div onClick={() => toggleExpandir(pedido.id)}
                  style={{ padding: '12px 14px', cursor: 'pointer' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 700, color: '#1a1a1a' }}>
                        Pedido #{pedido.id.slice(-6).toUpperCase()}
                      </div>
                      <div style={{ fontSize: 10, color: '#aaa', marginTop: 1 }}>
                        {formatarData(pedido.criadoEm)} · {pedido.fornecedor || 'Inove'}
                      </div>
                    </div>
                    <div style={{ background: st.bg, borderRadius: 20, padding: '3px 10px', fontSize: 10, fontWeight: 700, color: st.cor }}>
                      {st.label}
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: 10, color: '#aaa' }}>
                      {pedido.itens?.length || 0} {(pedido.itens?.length || 0) === 1 ? 'produto' : 'produtos'}
                    </span>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontSize: 15, fontWeight: 700, color: AZUL }}>
                        {formatarTotal(pedido.total)}
                      </span>
                      <span style={{ fontSize: 14, color: '#bbb', transform: aberto ? 'rotate(180deg)' : 'rotate(0deg)', display: 'inline-block', transition: 'transform 0.2s' }}>▼</span>
                    </div>
                  </div>
                </div>

                {aberto && (
                  <div style={{ borderTop: '1px solid #f0f0ee', padding: '10px 14px 14px' }}>

                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                      {['pendente', 'confirmado', 'em_entrega', 'entregue'].map((s, i, arr) => {
                        const idx   = arr.indexOf(pedido.status);
                        const ativo = i <= idx;
                        return (
                          <React.Fragment key={s}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, zIndex: 1 }}>
                              <div style={{ width: 24, height: 24, borderRadius: '50%', background: ativo ? AZUL : '#e0e0dd', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: ativo ? '#fff' : '#bbb', fontWeight: 700 }}>
                                {ativo ? '✔' : i + 1}
                              </div>
                              <span style={{ fontSize: 8, color: ativo ? AZUL : '#bbb', fontWeight: ativo ? 600 : 400, textAlign: 'center', whiteSpace: 'nowrap' }}>
                                {STATUS[s].label}
                              </span>
                            </div>
                            {i < arr.length - 1 && (
                              <div style={{ flex: 1, height: 2, background: i < arr.indexOf(pedido.status) ? AZUL : '#e0e0dd', margin: '0 4px', marginBottom: 16 }} />
                            )}
                          </React.Fragment>
                        );
                      })}
                    </div>

                    {(pedido.pagamento || pedido.prazo) && (
                      <div style={{ background: '#f8f8f7', borderRadius: 8, padding: '8px 10px', marginBottom: 10, fontSize: 11, color: '#555', lineHeight: 1.8 }}>
                        {pedido.pagamento && <div><span style={{ color: '#aaa' }}>Pagamento: </span>{pedido.pagamento}</div>}
                        {pedido.prazo     && <div><span style={{ color: '#aaa' }}>Prazo: </span>{pedido.prazo}</div>}
                        {pedido.horario   && <div><span style={{ color: '#aaa' }}>Horário: </span>{pedido.horario}</div>}
                      </div>
                    )}

                    <div style={{ fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>
                      Produtos
                    </div>
                    {(pedido.itens || []).map((p, idx) => (
                      <div key={idx} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '7px 0', borderBottom: '1px solid #f4f4f2' }}>
                        <div>
                          <div style={{ fontSize: 12, color: '#1a1a1a', fontWeight: 500 }}>{p.nome}</div>
                          <div style={{ fontSize: 10, color: '#bbb', marginTop: 1 }}>{p.cod} · Qtd: {p.qtd}</div>
                        </div>
                        <span style={{ fontSize: 12, fontWeight: 600, color: AZUL }}>{p.preco}</span>
                      </div>
                    ))}

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
                      <span style={{ fontSize: 12, color: '#888', fontWeight: 500 }}>Total do pedido</span>
                      <span style={{ fontSize: 16, fontWeight: 700, color: AZUL }}>{formatarTotal(pedido.total)}</span>
                    </div>

                    {pedido.observacao && (
                      <div style={{ marginTop: 10, background: '#fffbeb', borderRadius: 8, padding: '8px 10px', fontSize: 11, color: '#92400e' }}>
                        📝 {pedido.observacao}
                      </div>
                    )}

                    <button onClick={() => onNavegar('catalogo')}
                      style={{ width: '100%', marginTop: 12, background: '#f0f4ff', border: `1px solid ${AZUL}`, borderRadius: 10, padding: '10px', fontSize: 12, fontWeight: 600, color: AZUL, cursor: 'pointer' }}>
                      🔄 Repetir Pedido
                    </button>
                  </div>
                )}
              </div>
            );
          })
        )}
        <div style={{ height: 12 }} />
      </div>
    </div>
  );
}

export default Historico;